export const FORMAT_IMG = ['jpg', 'jpeg', 'gif', 'bmp', 'png'];
export const FORMAT_VIDEO = ['m4v', 'avi', 'mpg', 'mp4', 'webm', 'MOV'];
export const FORMAT_WORD = ['doc', 'docx'];
export const FORMAT_EXCEL = ['xls', 'xlsx'];
export const FORMAT_POWERPOINT = ['ppt', 'pptx'];
export const FORMAT_PDF = ['pdf'];
export const FORMAT_PHOTOSHOP = ['psd'];
export const FORMAT_ILLUSTRATOR = ['ai', 'esp'];
